import { RArray, RMap, RMutableMap } from "../collections";
import { cartesianProduct, makeImmutable } from "../core";
import { CustomParameterSet, MenuSection, MenuSectionId, ProductInstanceVariant, ProductInstanceVariantId, } from "../ordering";
export class MenuSectionParser {
    constructor(params) {
        this.productTypes = params.productTypes;
        this.customParameterTypes = params.customParameterTypes;
        makeImmutable(this);
    }
    parse(id, section) {
        if (section.content.tag !== "Products") {
            return null;
        }
        const variants = new RArray(section.content.items)
            .mapOptional(([, item]) => {
            if (item.tag !== "SingleProduct") {
                return null;
            }
            const productId = item.itemProduct;
            const productType = this.productTypes.rawFind(productId);
            const dropdownIds = section.dropdownParameters;
            if (productType === null) {
                return null;
            }
            return this.parseProductInstanceVariants(productType, dropdownIds);
        })
            .flatMap((productVariants) => productVariants);
        const variantsByProductType = RMutableMap.empty();
        for (const variant of variants) {
            const productTypeVariants = variantsByProductType.getOrCreate(variant.productType.id, () => []);
            productTypeVariants.push(variant);
        }
        return new MenuSection({
            id: new MenuSectionId(id),
            variants: RMap.fromIterable(variantsByProductType.entries.map(([productTypeId, variants]) => [
                productTypeId,
                new RArray(variants),
            ])),
        });
    }
    parseProductInstanceVariants(productType, dropdownParameterIds) {
        const dropdownCustomParameters = new RArray(dropdownParameterIds).map((dropdownParameterId) => this.customParameterTypes.rawGet(dropdownParameterId));
        const dropdownParametersPair = dropdownCustomParameters.map((parameter) => [parameter, new RArray(parameter.choiceIds)]);
        const parameterCombinations = cartesianProduct(dropdownParametersPair);
        const variants = new RArray(parameterCombinations.map((combination, index) => new ProductInstanceVariant({
            id: new ProductInstanceVariantId(index),
            productType,
            customParameterChoices: CustomParameterSet.fromChoices(RMap.fromIterable(combination.entries())),
        })));
        return variants;
    }
}
